module.exports = __webpack_public_path__ + "img/prestige-profile-inactive@3x.png";